import React from 'react';
import { cofigsettingsdetails, getconfigdata } from '../../ReduxStore/Slice/ConfigSettings/ConfigSettings';
import { useState, useEffect } from 'react';
import sweetalert2 from 'sweetalert2';
import { useDispatch } from 'react-redux';

const ConfigSetting = () => {

  const dispatch = useDispatch();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));

  const [configdata, setCnfigdata] = useState({
    agent_id: agent_id || "",
    discount_oneoff_single: null,
    discount_oneoff_multiple: null,
    discount_ongoing_single: null,
    discount_ongoing_multiple: null,
    complexity_low: null,
    complexity_medium: null,
    complexity_high: null,
    risk_low: null,
    risk_medium: null,
    risk_high: null,
    quality_data_low: null,
    quality_data_medium: null,
    quality_data_high: null,
    frequency_meeting_low: null,
    frequency_meeting_medium: null,
    frequency_meeting_high: null,
    access_seniors_low: null,
    access_seniors_medium: null,
    access_seniors_high: null,
    admin_charge: '0',
    payment_type_non_dd: 0,
    payment_type_dd: 0,
    payment_type_upfront: 0,
    payment_type_50_50: 0,
    contract_type_ongoing: 0,
    contract_type_oneoff: 0,
    contract_type_payg: 0,
  });

  useEffect(() => {
    getconfigdetails();
  }, []);

  const getconfigdetails = async () => {
    const req = { agent_id: agent_id };
    await dispatch(getconfigdata(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setCnfigdata(response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  const Updateconfig = async () => {
    const req = { ...configdata };
    await dispatch(cofigsettingsdetails(req)).unwrap()
      .then((res) => {
        if (res.status) {
          sweetalert2.fire({
            title: 'Success',
            text: res.message,
            icon: 'success',
            confirmButtonText: 'OK',
            timer: 3000,
            timerProgressBar: true
          });
        } else {
          sweetalert2.fire({
            title: 'Error',
            text: res.message,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePositiveInput = (key, value) => {
    const regex = /^(?!0\d)\d*(\.\d*)?$/;

    if (['payment_type_non_dd','payment_type_dd','payment_type_upfront','payment_type_50_50','contract_type_ongoing','contract_type_oneoff','contract_type_payg'].includes(key)) {
      if (value === '' || (regex.test(value))) {
        setCnfigdata({ ...configdata, [key]: value });
      }
    }
    else {
      if (value === '' || (regex.test(value) && parseFloat(value) <= 100)) {
        setCnfigdata({ ...configdata, [key]: value });
      }
    }


  };

  return (
    <div className="config-setting-container">
      <div className="pagetitle mb-5">
        <h4 className='page-title' style={{ fontSize: '24px' }}>Configuration Settings</h4>
      </div>

      <section className="section">
        <div className="row">
          <h5 className="text-pink mb-3" style={{ fontSize: '18px', fontWeight: '700' }}>Discount Configuration</h5>

          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">One-Off Services (Single Service)</div>
              <div className="card-body pt-4">
                <div className="row align-items-center">
                  <label className="col-sm-3 col-form-label">Discount value:</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      value={configdata.discount_oneoff_single || ''}
                      onChange={(e) => handlePositiveInput('discount_oneoff_single', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">One-Off Services (Multiple Services)</div>
              <div className="card-body pt-4">
                <div className="row align-items-center">
                  <label className="col-sm-3 col-form-label">Discount value:</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      value={configdata.discount_oneoff_multiple || ''}
                      onChange={(e) => handlePositiveInput('discount_oneoff_multiple', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">Ongoing Services (Single Service)</div>
              <div className="card-body pt-4">
                <div className="row align-items-center">
                  <label className="col-sm-3 col-form-label">Discount value:</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      value={configdata.discount_ongoing_single || ''}
                      onChange={(e) => handlePositiveInput('discount_ongoing_single', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">Ongoing Services (Multiple Services)</div>
              <div className="card-body pt-4">
                <div className="row align-items-center">
                  <label className="col-sm-3 col-form-label">Discount value:</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      value={configdata.discount_ongoing_multiple || ''}
                      onChange={(e) => handlePositiveInput('discount_ongoing_multiple', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h5 className="text-pink mb-3" style={{ fontSize: '18px', fontWeight: '700' }}>Multipliers</h5>
          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">Complexity & Risk</div>
              <div className="card-body pt-4">
                {['low', 'medium', 'high'].map(level => (
                  <div className="row align-items-center mb-3" key={level}>
                    <label className="col-sm-3 col-form-label">{level.charAt(0).toUpperCase() + level.slice(1)}:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata[`complexity_${level}`] || ''}
                        onChange={(e) => handlePositiveInput(`complexity_${level}`, e.target.value)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">Risk</div>
              <div className="card-body pt-4">
                {['low', 'medium', 'high'].map(level => (
                  <div className="row align-items-center mb-3" key={level}>
                    <label className="col-sm-3 col-form-label">{level.charAt(0).toUpperCase() + level.slice(1)}:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata[`risk_${level}`] || ''}
                        onChange={(e) => handlePositiveInput(`risk_${level}`, e.target.value)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div> */}

          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">Quality of Data</div>
              <div className="card-body pt-4">
                {[
                  { key: "low", label: "Good" },
                  { key: "medium", label: "Average" },
                  { key: "high", label: "Poor" },
                ].map(item => (
                  <div className="row align-items-center mb-3" key={item.key}>
                    <label className="col-sm-3 col-form-label">{item.label}:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata[`quality_data_${item.key}`] || ''}
                        onChange={(e) => handlePositiveInput(`quality_data_${item.key}`, e.target.value)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>



          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">Frequency of meetings & Access to Seniors/ Experts</div>
              <div className="card-body pt-4">
                {['low', 'medium', 'high'].map(level => (
                  <div className="row align-items-center mb-3" key={level}>
                    <label className="col-sm-3 col-form-label">{level.charAt(0).toUpperCase() + level.slice(1)}:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata[`frequency_meeting_${level}`] || ''}
                        onChange={(e) => handlePositiveInput(`frequency_meeting_${level}`, e.target.value)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">Access to Seniors/ Experts</div>
              <div className="card-body pt-4">
                {['low', 'medium', 'high'].map(level => (
                  <div className="row align-items-center mb-3" key={level}>
                    <label className="col-sm-3 col-form-label">{level.charAt(0).toUpperCase() + level.slice(1)}:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata[`access_seniors_${level}`] || ''}
                        onChange={(e) => handlePositiveInput(`access_seniors_${level}`, e.target.value)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div> */}

          <h5 className="text-pink mb-3" style={{ fontSize: '18px', fontWeight: '700' }}>Payment Type & Contract Type</h5>

          <div className='d-flex gap-4'>
            <div className="col-md-6 mb-4">
              <div className="card">
                <div className="card-header">Payment Type</div>
                <div className="card-body pt-4">
                  <div className="row align-items-center">
                    <label className="col-sm-3 col-form-label">Non DD:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata.payment_type_non_dd || ''}
                        onChange={(e) => handlePositiveInput('payment_type_non_dd', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row align-items-center">
                    <label className="col-sm-3 col-form-label">DD:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata.payment_type_dd || ''}
                        onChange={(e) => handlePositiveInput('payment_type_dd', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row align-items-center">
                    <label className="col-sm-3 col-form-label">Upfront:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata.payment_type_upfront || ''}
                        onChange={(e) => handlePositiveInput('payment_type_upfront', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row align-items-center">
                    <label className="col-sm-3 col-form-label">50-50:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata.payment_type_50_50 || ''}
                        onChange={(e) => handlePositiveInput('payment_type_50_50', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

              </div>


            </div>

            <div className="col-md-6 mb-4">
              <div className="card">
                <div className="card-header">Contract Type</div>
                <div className="card-body pt-4">
                  <div className="row align-items-center">
                    <label className="col-sm-3 col-form-label">Ongoing Service:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata.contract_type_ongoing || ''}
                        onChange={(e) => handlePositiveInput('contract_type_ongoing', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row align-items-center">
                    <label className="col-sm-3 col-form-label">One off Service:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata.contract_type_oneoff || ''}
                        onChange={(e) => handlePositiveInput('contract_type_oneoff', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row align-items-center">
                    <label className="col-sm-3 col-form-label">PAYG:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={configdata.contract_type_payg || ''}
                        onChange={(e) => handlePositiveInput('contract_type_payg', e.target.value)}
                      />
                    </div>
                  </div>
                </div>



              </div>


            </div>

          </div>



          <h5 className="text-pink mb-3" style={{ fontSize: '18px', fontWeight: '700' }}>Admin Charges</h5>

          <div className="col-md-6 mb-4">
            <div className="card">
              <div className="card-header">Enable Admin Charge for Manual Payments</div>
              <div className="card-body pt-4">
                <div className="d-flex justify-content-center gap-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="adminCharge"
                      id="adminChargeYes"
                      value="yes"
                      checked={Number(configdata.admin_charge) === 1}
                      onChange={() => handlePositiveInput('admin_charge', '1')}
                    />
                    <label className="form-check-label" htmlFor="adminChargeYes">
                      Yes
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="adminCharge"
                      id="adminChargeNo"
                      value="no"
                      checked={Number(configdata.admin_charge) === 0}
                      onChange={() => handlePositiveInput('admin_charge', '0')}
                    />
                    <label className="form-check-label" htmlFor="adminChargeNo">
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 text-end">
            <button type="submit" className="btn btn-pink" onClick={Updateconfig}>
              <i className="far fa-save"></i> Save
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConfigSetting;